export const types = {
  SET_LOADING: 'SET_LOADING',
  // SET_SESSION_PRICES: 'SET_SESSION_PRICES',
  SET_SESSION: 'SET_SESSION',
  SET_BAR: 'SET_BAR',

  SESSION_WITHOUT_PLACES: 'SESSION_WITHOUT_PLACES',

  SET_AUTH_TOKEN: 'SET_AUTH_TOKEN',
  SET_USER_SESSION_ID: 'SET_USER_SESSION_ID',
  SET_THEATRE_ID: 'SET_THEATRE_ID',
  SET_SESSION_ID: 'SET_SESSION_ID',
  SET_NOTIFICATIONS: 'SET_NOTIFICATIONS',

  SET_BAR_OPTION: 'SET_BAR_OPTION',
  SET_GENERAL_SCHEDULE_OPTION: 'SET_GENERAL_SCHEDULE_OPTION',

  SET_CITIES: 'SET_CITIES',
  SET_SCHEDULE: 'SET_SCHEDULE',
  SET_MOVIE: 'SET_MOVIE',

  SET_ORDER_ID: 'SET_ORDER_ID',

  LOAD_APP: 'LOAD_APP',
  SET_ID_TOKEN: 'SET_ID_TOKEN',

  GET_FILM_WITH_SCHEDULE: 'GET_FILM_WITH_SCHEDULE',
  RESET_FILM_WITH_SCHEDULE: 'RESET_FILM_WITH_SCHEDULE',

  SET_ORDER_INFO_AFTER_PAYMENT: 'SET_ORDER_INFO_AFTER_PAYMENT',

  USER_REGISTRATION_FROM_WIDGET: 'USER_REGISTRATION_FROM_WIDGET',

  // CUSTOMER_ACCOUNTS
  SET_CUSTOMER_ACCOUNTS: 'SET_CUSTOMER_ACCOUNTS',
  UNSELECT_CUSTOMER_ACCOUNTS: 'UNSELECT_CUSTOMER_ACCOUNTS',
  UNPICKED_CUSTOMER_ACCOUNTS: 'UNPICKED_CUSTOMER_ACCOUNTS',
  SET_CUSTOMER_ACCOUNT: 'SET_CUSTOMER_ACCOUNT',
  CALCULATE_CART: 'CALCULATE_CART',
  SET_THEATRE: 'SET_THEATRE',
  SET_THEATRE_PAYMENT_INFO: 'SET_THEATRE_PAYMENT_INFO',
  SET_ENABLED_PAYMENTS: 'SET_ENABLED_PAYMENTS',

  SET_DATA: 'SET_DATA',
  SET_PLACES: 'SET_PLACES',
  REFRESH_PLACES: 'REFRESH_PLACES',
  SET_PRICES: 'SET_PRICES',
  SET_SESSION_INFO: 'SET_SESSION_INFO',
  SET_MOVIE_INFO: 'SET_MOVIE_INFO',
  SET_HALLS: 'SET_HALLS',
  ADD_PLACE_TO_CART: 'ADD_PLACE_TO_CART',
  REMOVE_PLACE_FROM_CART: 'REMOVE_PLACE_FROM_CART',

  ADD_TO_REMOVED_PLACES_LIST: 'ADD_TO_REMOVED_PLACES_LIST',
  CLEAR_REMOVED_PLACES_LIST: 'CLEAR_REMOVED_PLACES_LIST',

  ADD_BAR_TO_CART: 'ADD_BAR_TO_CART',
  SET_DONATION_SIZE: 'SET_DONATION_SIZE',
  SET_PROMOCODE_VALUE: 'SET_PROMOCODE_VALUE',
  ADD_ERROR_PROMOCODE: 'ADD_ERROR_PROMOCODE',
  REMOVE_BAR_FROM_CART: 'REMOVE_BAR_FROM_CART',
  CLEAR_BAR_ZERO_ITEMS: 'CLEAR_BAR_ZERO_ITEMS',
  CLEAR_BAR: 'CLEAR_BAR',
  REMOVE_ADDED_CLASS_FROM_BAR: 'REMOVE_ADDED_CLASS_FROM_BAR',
  CHANGE_BAR_IN_CART: 'CHANGE_BAR_IN_CART',
  RESERVE_THICKETS: 'RESERVE_THICKETS',
  SET_TICKET_ORDER_ID: 'SET_TICKET_ORDER_ID',
  SET_LOCAL_ORDER_ID: 'SET_LOCAL_ORDER_ID',
  SET_TRANSACTION_ID: 'SET_TRANSACTION_ID',
  SET_BAR_ORDER_ID: 'SET_BAR_ORDER_ID',
  ADD_ERROR: 'ADD_ERROR',
  CLEAR_ERRORS: 'CLEAR_ERRORS',
  START_COUNTDOWN: 'START_COUNTDOWN',
  SET_PAYMENT_TYPE: 'SET_PAYMENT_TYPE',
  UPDATE_PROP_VALUE: 'UPDATE_PROP_VALUE',
  RESTORE_USER_DATA: 'RESTORE_USER_DATA',
  RESET_SESSION_END_AT: 'RESET_SESSION_END_AT',
  CLEAR_CART: 'CLEAR_CART',
  CLEAR_USER: 'CLEAR_USER',
  SET_USER_DATA: 'SET_USER_DATA',
  SET_USER_BALANCE: 'SET_USER_BALANCE',
  CHANGE_PAYMENT_WITH_BONUSES: 'CHANGE_PAYMENT_WITH_BONUSES',
  GET_TOTAL_SUM: 'GET_TOTAL_SUM',
  CALCULATE_USER_MAX_BONUSES: 'CALCULATE_USER_MAX_BONUSES',

  //socket events
  SOCKET_CONNECT: 'SOCKET_CONNECT',
  SOCKET_USER_SESSION_ID: 'SOCKET_USER_SESSION_ID',
  SOCKET_DISCONNECTING: 'SOCKET_DISCONNECTING',
  SOCKET_DISCONNECT: 'SOCKET_DISCONNECT',

  SET_START_FROM_SCHEDULE: 'SET_START_FROM_SCHEDULE',

  SET_THEATRES: 'SET_THEATRES',

  SET_DATA_FROM_GENERAL_SCHEDULE_BEFORE_UNMOUNTED:
    'SET_DATA_FROM_GENERAL_SCHEDULE_BEFORE_UNMOUNTED',

  SET_DATA_BAR: 'SET_DATA_BAR',

  SET_PROMO_CODE_DATA: 'SET_PROMO_CODE_DATA',
  CLEAR_PROMO_CODE_DATA: 'CLEAR_PROMO_CODE_DATA',

  SET_TICKETS_SUM_HARDCODE: 'SET_TICKETS_SUM_HARDCODE',

  SET_PRIVACY_POLICY: 'SET_PRIVACY_POLICY',

  SET_CURRENCY: 'SET_CURRENCY',

  SET_THEATER_PRIVACY_DOCUMENTS: 'SET_THEATER_PRIVACY_DOCUMENTS',

  SET_VK_WIDGET: 'SET_VK_WIDGET',

  SET_VK_MOBILE_WIDGET: 'SET_VK_MOBILE_WIDGET'
};
